import { jsx, Fragment } from 'react/jsx-runtime';
import { d as dist } from './index-d8f55c20.js';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

var RedirectWrapper = function (_a) {
    _a.url;
    var history = useHistory();
    var idToken = dist.useOidcIdToken().idToken;
    useEffect(function () {
        if (idToken && history) {
            history.replace('/');
        }
    }, [idToken, history]);
    return jsx(Fragment, {});
};

export { RedirectWrapper as R };
